import React from 'react'

import ControlledModal from '../../../components/modals/ControlledModal'
import ModalContent from './ModalContent'
import ModalHeader from './ModalHeader'
import Separator from '../../../components/helpers/Separator'

const ExportModal = props => {
  return (
    <ControlledModal width="32rem" {...props}>
      <ModalHeader />
      <Separator weight={4} />
      <ModalContent />
    </ControlledModal>
  )
}

export default ExportModal
